import { trigger, animate, transition, style } from '@angular/animations';

export const slideInOutX = trigger('slideInOutX', [
  transition(':enter', [
    style({ transform: 'translateX(100%)' }),
    animate('200ms ease-in', style({ transform: 'translateX(0%)' })),
  ]),
  transition(':leave', [animate('200ms ease-in', style({ transform: 'translateX(100%)' }))]),
]);
